var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"game"}},[(!_vm.game.name)?_c('loader'):_c('alfakodo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }